var ytplayer,
  videos,
  first_video,
  ytplayer_arr = [];
function onYouTubeIframeAPIReady() {
  if (document.getElementsByClassName('yt-player').length > 0)
    for (videos = document.getElementsByClassName('yt-player'), i = 0, videos.length; i < videos.length; i++)
      (videos[i].id = 'yt-player-' + i),
        (window.ytplayer_arr[i] = new YT.Player('yt-player-' + i, {
          height: '360',
          width: '640',
          videoId: videos[i].getAttribute('data-ytid'),
          playerVars: { autoplay: '0', controls: '2', rel: '0', showinfo: '0' },
        }));
  else {
    obj = document.getElementById('yt-player');
    let e = null;
    obj && (e = obj.getAttribute('data-ytid')),
      document.getElementsByClassName('wll-product-video').length > 0
        ? ((videos = document.getElementsByClassName('wll-product-video')),
          (first_video = videos[0]),
          (window.ytplayer = new YT.Player('yt-player', {
            height: '360',
            width: '640',
            videoId: first_video.getAttribute('data-id'),
            playerVars: { autoplay: '0', controls: '2', rel: '0', showinfo: '0' },
          })),
          (document.getElementById('player-video-title').innerHTML = first_video.getAttribute('data-title')),
          (document.getElementById('player-video-desc').innerHTML = first_video.getAttribute('data-desc')))
        : e && (ytplayer = new YT.Player('yt-player', { height: '360', width: '640', videoId: e }));
  }
}
if (document.querySelector('.yt-player, #yt-player')) {
  (tag = document.createElement('script')), (tag.src = 'https://www.youtube.com/iframe_api');
  let e = document.getElementsByTagName('script')[0];
  e.parentNode.insertBefore(tag, e);

    // Support Articles timestamp and scroll into view
  document.addEventListener('DOMContentLoaded', function () {
    var buttons = document.querySelectorAll('.timestamp-button');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var time = parseInt(this.getAttribute('data-time'));
        ytplayer = ytplayer_arr.length > 0 ? ytplayer_arr[0] : ytplayer;
        if (ytplayer) {
          ytplayer.seekTo(time, true);
          // Scroll smoothly to the video player
          var offsetTop = ytplayer.g.getBoundingClientRect().top + window.scrollY - 50;
          window.scrollTo({ top: offsetTop, behavior: "smooth" });
        }
      });
    });
  });
}
